import userHTTP from '@/api/modules/user/user'
import localStorage from '@/providers/ls'

let users = {}

export default {
	getAll (params = {}) {
		return new Promise((resolve, reject) => {
			let pagination = {
				curr: null,
				count: null,
				next: null
			}
			function _get () {
				if (pagination.next !== null) params.page = pagination.next
				userHTTP.findAll(params, true).then((response) => {
					let headers = response.headers
					let _users = response.body
					_users.forEach((value, key) => {
						users[value.id] = value
					})
					pagination.curr = parseInt(headers.get('X-Pagination-Current-Page'))
					pagination.count = parseInt(headers.get('X-Pagination-Page-Count'))

					if (pagination.curr < pagination.count) {
						pagination.next = pagination.curr + 1
						_get()
					} else {
						localStorage.set('users', users)
						resolve(users)
					}
				})
			}
			_get()
		})
	},

	getLastUpdated () {
		const users = localStorage.get('users')
		let usersArr = []
		let i = 0
		if (users.length === 0) return false
		for (let key in users) {
			usersArr.push(users[key])
			if (i === Object.keys(users).length - 1) {
				usersArr = usersArr.sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at))
				return usersArr.reverse()[0]
			}
			i++
		}
	}
}



// WEBPACK FOOTER //
// ./src/providers/user/user.js